import { useEffect, useRef } from 'react'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { fetchAllProviders } from '@store/actions/providermanagement.action'

/**
 * Custom hook that automatically fetches providers when clinic changes
 * Use this in components that need clinic-filtered providers
 */
export const useClinicProviders = (): void => {
  const dispatch = useAppDispatch()
  const selectedClinic = useAppSelector((state) => state.clinic.selectedClinic)
  const lastFetchedClinicId = useRef<string | null>(null)

  useEffect(() => {
    if (selectedClinic) {
      const clinicId = selectedClinic.clinic_id
      if (lastFetchedClinicId.current !== clinicId) {
        lastFetchedClinicId.current = clinicId
        dispatch(fetchAllProviders())
      }
    } else {
      lastFetchedClinicId.current = null
    }
  }, [selectedClinic, dispatch])
}
